import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store';  //or use a full path to ./store 

// import store from '.././store.js'

// import HomeV2 from '../views-v2/Home.vue'

// import Delegation from '../views/Delegation'

// import componentsHelpers from '../classes/componentHelpers'

// import Business from '../views/Business.vue'

// import Brand from '../views/Brand.vue'

// import Classes from '../views/Classes.vue'

// import Slots from '../views/Slots.vue'

// import FitnessDashboard from '../views/FitnessDashboard'

// import PitchFitnessDashboard from '../views/PitchFitnessDashboard'


// import Sessions from '../views/Sessions.vue'

// import Bookings from '../views/Bookings.vue'

// import BookingsParent from '../views/BookingsParent.vue'

// import Search from '../views/Search.vue'

import callback from '../views/Callback.vue'

import Profile from "../views/Profile.vue";

// import Activities from "../views/Activities.vue";

import successfulPayment from '../components/SuccessfulPayment'

import FailedPayment from '../components/FailedPayment'

// import adminSuccessfulPayment from '../admin-section/components/SuccessfulPayment'

// import adminFailedPayment from '../admin-section/components/FailedPayment'


// import pitch from '../views/Pitches'

// import player from '../views/Player'

// import groups from '../views/PlayersGroups'

// import pitchSlot from '../views/PitchSlot'

import privacyPolicy from '../components/PrivacyPolicy';

// import bookingPitches from '../views/BookingPitches';


// import appLaunch from '../views/BookingPitches';

// import fullBrandPage from '../views/FullBrandPage';

// import fullBusinessPage from '../views/FullBusinessPage';

// import fullClassPage from '../views/FullClassPage';


// import fullInstructorPage from '../views/FullInstructorPage';

// import fullPitchPage from '../views/FullPitchPage';

// import businessMemberships from '../views/BusinessMemberships'

// import clientSubscriptions from '../views/ClientSubscriptions'

// import brokerBusiness from '../views/BrokerBusiness'

// import { authGuard } from "../auth/authGuard";

// const ProjectList = () => import('@/components/ProjectList.vue');

// const showNewMode = false;


// console.log(`showNewMode: ${showNewMode}`);
Vue.use(VueRouter)

let isNewStyle = true;

let showNewMode  = true;

let businessView = false;

// const showNewMode  = process.env.NODE_ENV == "development"

if(localStorage.hasOwnProperty("businessView")){

  let value;
  
  if(!localStorage.getItem('businessView').includes('undefined')){

    value = localStorage.getItem('businessView');

    // console.log(`value: ${value} `);
    if (value === null) {
        value = false;
    } else {

        value = JSON.parse(value)
    }

    value = JSON.parse(value)

    businessView = value;

  }
}

// console.log(`businessView: ${businessView}`)

// console.log(`showNewMode: ${showNewMode}`)

showNewMode = true;

if(localStorage.hasOwnProperty('myStyle')){

  const style = localStorage.getItem('myStyle');

  // console.log(`style: ${style}`)

  if(style == 'pink'){

    isNewStyle = false;
  }

}else if(process.env.VUE_APP_SERVER_MY_MODE == 'production'){

  isNewStyle = false;
}
  


// console.log(`isNewStyle: ${isNewStyle}`);

const routes = [

  {
    path: '/index.html',
    name: 'index',

    component: ()=>{

      if(!showNewMode){

        // return import(/* webpackChunkName: "myHome" */ '../views/Home.vue')
        return import(/* webpackChunkName: "myHome" */ '../views/NewHome.vue')
      }else{

        return import(/* webpackChunkName: "myHomev2" */ '../views-v2/Home.vue')
      }
    }

// beforeEnter: authGuard
  },
  
  {
    path: '/',
    name: 'main',
    // component: Home,

    component: ()=>{
      
      // console.log(`in /main`);

      if(!showNewMode){

        // console.log(`in /main with if`);

        // return import(/* webpackChunkName: "myHome" */ '../views/Home.vue')
        return import(/* webpackChunkName: "myHome" */ '../views/NewHome.vue')

      }else{
        // console.log(`in /main with else`);

        return import(/* webpackChunkName: "myHomev2" */ '../views-v2/Home.vue')
      }
    }
// beforeEnter: authGuard
  },

  {
    path: '/home',
    name: 'home',
    // component: Home
    component: ()=>{

      if(!showNewMode){

        // return import(/* webpackChunkName: "myHome" */ '../views/Home.vue')
        return import(/* webpackChunkName: "myHome" */ '../views/NewHome.vue')
      }else{

        return import(/* webpackChunkName: "myHomev2" */ '../views-v2/Home.vue')
      }
    }
  },

  {
    path: "/profile",
    name: "profile",
    // component: Profile,
    // beforeEnter: authGuard

    component: ()=>{

      if(!showNewMode){

        return import(/* webpackChunkName: "profile" */ '../views/Profile.vue')
      }else{

        return import(/* webpackChunkName: "v2-profille" */ '../views-v2/Profile.vue')
      }
    }
  },

  // {
  //   path: "/admin/main",
  //   name: "adminMain",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/AppAdmin.vue')
  //   }
  // },

  // {
  //   path: "/admin/loginAsUser",
  //   name: "adminLoginAsUser",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/LoginAsUser.vue')
  //   }
  // },

  // {
  //   path: "/admin/Profiles",
  //   name: "Profiles",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/Profiles.vue')
  //   }
  // },

  // {
  //   path: "/admin/requests",
  //   name: "adminRequests",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/Requests.vue')
  //   }
  // },

  // {
  //   path: "/admin/profile",
  //   name: "adminProfile",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/Profile.vue')
  //   }
  // },

  {
    path: "/packages",
    name: "packages",
    // component: Profile,
    // beforeEnter: authGuard

    component: ()=>{

      return import(/* webpackChunkName: "v2-packages" */ '../views-v2/Payment.vue')
    }
  },

  {
    path: '/brand',
    name: 'brand',
    // component: Brand
    component: () => import(/* webpackChunkName: "businessOne" */ '../views/Brand.vue'),

  },

  // {
  //   path: "/admin/brand",
  //   name: "adminBrand",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/Brand.vue')
  //   }
  // },

  {
    path: "/business",
    name: "business",
    // component: Business,
    component: () => import(/* webpackChunkName: "businessOne" */ '../views/Business.vue'),

    // beforeEnter: authGuard
  },

  // {
  //   path: "/admin/business",
  //   name: "adminBusiness",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/Business.vue')
  //   }
  // },

  {
    path: "/delegation",
    name: "delegation",
    // component: Delegation,
    // beforeEnter: authGuard
    component: () => import(/* webpackChunkName: "businessOne" */ '../views/Delegation.vue'),

  },

  {
    path: "/classes",
    name: "classes",
    // component: Classes,
    component: () => import(/* webpackChunkName: "businessTwo" */ '../views/Classes.vue'),

    // beforeEnter: authGuard
  },

  // {
  //   path: "/admin/classes",
  //   name: "adminClasses",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/Classes.vue')
  //   }
  // },

  // {
  //   path: "/slots",
  //   name: "slots",
  //   component: Slots,
  // },

  {
    path: "/fitnessDashboard",
    name: "fitnessDashboard",
    // component: FitnessDashboard,
    component: () => import(/* webpackChunkName: "businessTwo" */ '../views/FitnessDashboard.vue'),

  },

  // {
  //   path: "/admin/fitnessDashboard",
  //   name: "adminFitnessDashboard",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/FitnessDashboard.vue')
  //   }
  // },

  {
    path: "/Sessions",
    name: "Sessions",
    // component: Sessions,

    component: ()=>{

      if(!showNewMode){

        return import(/* webpackChunkName: "clientTwo" */ '../views/Sessions.vue')
      }else{
        
        return import(/* webpackChunkName: "clientTwov2" */ '../views-v2/Sessions.vue')
      }
    }
  },

  // {
  //   path: "/bookings",
  //   name: "bookings",
  //   component: Bookings,
  // component: BookingsParent,

  // },

  {
    path: "/bookings",
    name: "bookings",
    // component: BookingsParent
    // component: () => import(/* webpackChunkName: "clientOne" */ '../views/BookingsParent.vue'),

    component: ()=>{

      if(!showNewMode){

        return import(/* webpackChunkName: "clientOne" */ '../views/BookingsParent.vue')
      }else{

        return import(/* webpackChunkName: "v2-clientOne" */ '../views-v2/MyTickets.vue')
      }
    }
    // component: componentsHelpers.getDevelopmentMode() == 'development' ? BookingsParent : Bookings,
  },

  {
    path: "/PnadiSearch",
    name: "search",
    // component: Search,

    component: ()=>{

      if(!showNewMode){

        return import(/* webpackChunkName: "clientTwo" */ '../views/Search.vue')
      }else{

        return import(/* webpackChunkName: "v2-browse" */ '../views-v2/Browse.vue')
      }
    }

  },

  {
    path: '/callback',
    name: 'callback',
    component: callback,
    // component: () => import(/* webpackChunkName: "mainApp" */ '../views/Callback.vue'),


    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/successfulPayment',
    name: 'successfulPayment',
    component: successfulPayment,
    // component: () => import(/* webpackChunkName: "payment" */ '../components/SuccessfulPayment.vue'),

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/failedPayment',
    name: 'failedPayment',
    component: FailedPayment,
    // component: () => import(/* webpackChunkName: "payment" */ '../components/FailedPayment.vue'),

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  // {
  //   path: '/admin/successfulPayment',
  //   name: 'adminSuccessfulPayment',
  //   component: adminSuccessfulPayment,
  // },

  // {
  //   path: 'admin/failedPayment',
  //   name: 'adminFailedPayment',
  //   component: adminFailedPayment,
  // },

  {
    path: "/activities",
    name: "activities",
    // component: Activities,

    component: ()=>{

      if(!showNewMode){

        return  import(/* webpackChunkName: "clientOne" */ '../views/Activities.vue')
      }else{

        return import(/* webpackChunkName: "v2-activities" */ '../views-v2/Activities.vue')
      }
    }
  },


  {
    path: "/pitch",
    name: "pitch",
    // component: pitch,
    component: () => import(/* webpackChunkName: "businessThree" */ '../views/Pitches.vue'),

  },

  // {
  //   path: "/admin/pitch",
  //   name: "adminPitch",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/Pitches.vue')
  //   }
  // },

  {
    path: "/player",
    name: "player",
    // component: player,
    // component: () => import(/* webpackChunkName: "clientThree" */ '../views/Player.vue'),

    component: ()=>{

      if(!showNewMode){

        return  import(/* webpackChunkName: "Player" */ '../views/Player.vue')
      }else{

        return import(/* webpackChunkName: "v2-Player" */ '../views-v2/Player.vue')
      }
    }
  },

  {
    path: "/playersgroups",
    name: "playersgroups",
    // component: groups,
    // component: () => import(/* webpackChunkName: "clientThree" */ '../views/PlayersGroups.vue'),

    component: ()=>{

      if(!showNewMode){

        return  import(/* webpackChunkName: "PlayersGroups" */ '../views/PlayersGroups.vue')
      }else{

        return import(/* webpackChunkName: "v2-PlayersGroups" */ '../views-v2/PlayersGroups.vue')
      }
    }
  },

  // {
  //   path: "/Pitchdashboard",
  //   name: "pitchdashboard",
  //   // component: pitchSlot,
  //   component: () => import(/* webpackChunkName: "businessThree" */ '../views/PitchSlot.vue'),

  // },

  {
    path: "/Pitchdashboard",
    name: "pitchdashboard",
    // component: pitchSlot,
    component: () => import(/* webpackChunkName: "businessThree" */ '../views/PitchFitnessDashboard.vue'),

  },

  // {
  //   path: "/admin/Pitchdashboard",
  //   name: "adminPitchdashboard",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/PitchFitnessDashboard.vue')
  //   }
  // },

  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    // component: privacyPolicy
    // component: () => import(/* webpackChunkName: "businessThree" */ '../components/PrivacyPolicy.vue'),

    component: ()=>{

      if(!showNewMode){

        return  import(/* webpackChunkName: "PlayersGroups" */ '../components/PrivacyPolicy.vue')
      }else{

        return import(/* webpackChunkName: "v2-PlayersGroups" */ '../views-v2/PrivacyPolicy.vue')
      }
    }

  },

  {
    path: "/bookingPitches",
    name: "bookingPitches",
    // component: bookingPitches,
    component: ()=>{

      if(!showNewMode){

        return import(/* webpackChunkName: "clientThree" */ '../views/BookingPitches.vue')
      }else{

        return import(/* webpackChunkName: "clientThreev2" */ '../views-v2/BookingPitches.vue')
      }
    }
  },

  // {
  //   path: "/appLaunch",
  //   name: "appLaunch",
  //   component: appLaunch,
  // },

  {
    path: "/brandPage",
    name: "brandPage",
    // component: fullBrandPage,
    component: () => import(/* webpackChunkName: "brandPage" */ '../views/FullBrandPage.vue'),
    
  },

  {
    path: "/businessPage",
    name: "businessPage",
    // component: fullBusinessPage,
    // component: () => import(/* webpackChunkName: "businessPage" */ '../views/FullBusinessPage.vue'),
    component: () => import(/* webpackChunkName: "businessPage" */ '../components-v2/MyPages/BusinessPageParent.vue'),

    // component: async () => {
    //   if(await router.app.$auth.isAuthenticated()){

    //     console.log(`in businessPage for public`);
    //     return import(/* webpackChunkName: "businessPage" */ '../components-v2/MyPages/BusinessPageForPublic.vue')
    //   }
    //   else{
    //     console.log(`in just businessPage`);

    //     return import(/* webpackChunkName: "businessPage" */ '../components-v2/MyPages/BusinessPage.vue')

    //   }
    // },

  },

  {
    path: "/instructorPage",
    name: "instructorPage",
    // component: fullInstructorPage,
    // component: () => import(/* webpackChunkName: "brandPage" */ '../views/FullInstructorPage.vue'),
    component: () => import(/* webpackChunkName: "brandPage" */ '../components-v2/MyPages/InstructorPage.vue'),

  },

  {
    path: "/classPage",
    name: "classPage",
    // component: fullClassPage,
    component: () => import(/* webpackChunkName: "brandPage" */ '../views/FullClassPage.vue'),

  },


  {
    path: "/pitchPage",
    name: "pitchPage",
    // component: fullPitchPage,
    component: () => import(/* webpackChunkName: "brandPage" */ '../views/FullPitchPage.vue'),
  },

  {
    path: "/businessMemberships",
    name: "businessMemberships",
    // component: businessMemberships,
    component: () => import(/* webpackChunkName: "businessThree" */ '../views/BusinessMemberships.vue'),
  },

  // {
  //   path: "/admin/businessMemberships",
  //   name: "adminBusinessMemberships",

  //   component: ()=>{

  //     return import(/* webpackChunkName: "admin" */ '../admin-section/views/BusinessMemberships.vue')
  //   }
  // },

  {
    path: "/clientSubscriptions",
    name: "clientSubscriptions",
    // component: clientSubscriptions,

    component: ()=>{

      if(!showNewMode){

        return import(/* webpackChunkName: "businessThree" */ '../views/ClientSubscriptions.vue')
      }else{

        return import(/* webpackChunkName: "businessThreev2" */ '../views-v2/AllMemberships.vue')
      }
    }
  },


  {
    path: "/brokerBusiness",
    name: "brokerBusiness",
    // component: clientSubscriptions,
    component: () => import(/* webpackChunkName: "brokerBusiness" */ '../views/BrokerBusiness.vue'),
  },

  {
    path: "/publicSessions",
    name: "publicSessions",
    // component: pitch,
    component: () => import(/* webpackChunkName: "publicUsers" */ '../publicUsersComponents/sessions/PublicInfoSessions.vue'),

  },
  {
    path: "/publicPitches",
    name: "publicPitches",
    // component: pitch,
    component: () => import(/* webpackChunkName: "publicUsers" */ '../publicUsersComponents/pitches/PublicInfoPitches.vue'),

  },

  {
    path: "/publicMemberships",
    name: "publicMemberships",
    // component: pitch,
    component: () => import(/* webpackChunkName: "publicUsers" */ '../publicUsersComponents/Memberships/PublicInfoAllMemberships.vue'),

  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// very basic "setup" of a global guard

router.beforeEach(async (to, from, next) => {

  // console.log(`router, userId: ${store.state.userId}`);
  store.commit('changeLoader', true)

  
  if (process.env.NODE_ENV === "development") {

    // console.log(`in development`);
    // console.log(`store.state.appLoaded: ${store.state.appLoaded}`);
    // console.log(`from.name: ${from.name}`);

    // console.log(`to.name: ${to.name}`);

    if(to.name == 'profile'){
      // console.log(`if 1`)
      next();
    }
    else if(store.state.appLoaded == false){
      // console.log(`if 2`)

        next();
      }
      else{

        // console.log(`store.state.userId: ${store.state.userId}`);

        if(store.state.userId == 0){
          
          // console.log(`if 21`)
          // next('/profile')
          // router.push({ path: '/profile' });
          if(from.name == 'profile'){
            // console.log(`if 211`)

            // next('/profile')

            router.go(0);

          }else{

            // console.log(`if 212`)

            next('/profile')
          }

        }else{
          
          // console.log(`if 22`)

          // console.log(`if 4`)

          next();
        }
      }

    // if(to.name == 'profile'){

    //   next();
    // }
    // else if(store.state.userId == 0){

    //   next('/profile')
    // }else{

    //   next()

    // }
  }
  else{

    // console.log(`in production`);

    if(to.name == 'app' || to.name == 'home'  || to.name == 'privacyPolicy' 
    || to.name =='publicSessions' || to.name =='publicPitches' || to.name =='publicMemberships' 
    || to.name == 'businessPage')
    {
      // console.log(`in first if`);

      next();
    }
    else if(to.name == 'callback') { // check if "to"-route is "callback" and allow access
  
    // console.log(`inside router - going to call back`);
      next();
    }
     else if (await router.app.$auth.isAuthenticated()) { 
       // if authenticated allow access
      //  console.log(`in Authenticated`);

      // let value = await router.app.$auth.isAuthenticated();
      //  console.log(`inside router - before condition and isAutehnticated is ${value}`);
      
      //console.log(`inside router`);

      //2- reverse the following

      // console.log(`store.state.appLoaded: ${store.state.appLoaded}`);
      
      if(to.name == 'profile'){
        next();
    }
    else if(store.state.appLoaded == false){

        next();
      }
      else{


        if(store.state.userId == 0){
          
          if(from.name == 'profile'){

            router.go(0);

          }else{

            next('/profile')
          }

        }else{

          next();
        }
      }

      // if(to.name == 'profile'){
      //   next()
      // }else{
      //   next('/profile')
      // }


      // next({
      //   name: to.name
      // })
    } else {
      
      // console.log(`in unAuthenticated`);
  
      next('/home')
      // trigger auth0 login
      // router.app.$auth.login() 
    }
  }
})

router.afterEach((to, from)=>{

  store.commit('changeLoader', false)

  // console.log(`store.state.loadingPage: ${store.state.loadingPage}`);
})

export default router
